import { render, staticRenderFns } from "./tab-qrcodes.vue?vue&type=template&id=20badcc3&"
import script from "./tab-qrcodes.vue?vue&type=script&lang=js&"
export * from "./tab-qrcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports